import React, { useRef, useState, useEffect } from 'react';
import '../styles/testimonials.css';
import { fetchReviews } from '../functions/Reviews';

const Testimonials = () => {
  const [testimonialData, setTestimonialData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getReviews = async () => {
      try {
        const reviews = await fetchReviews();
        setTestimonialData(reviews);
      } catch (error) {
        // console.error("Error fetching reviews:", error);
      } finally {
        setLoading(false);
      }
    };

    getReviews();
  }, []);

  const rowRef = useRef(null);

  const scroll = (direction) => {
    if (rowRef.current) {
      const scrollAmount = rowRef.current.offsetWidth * 0.7;
      rowRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  const renderStars = (rating) => {
    return [...Array(5)].map((_, i) => (
      <span key={i} className={i < rating ? "sway-star sway-star--filled" : "sway-star"}>
        {i < rating ? <i className="fas fa-star"></i> : <i className="far fa-star"></i>}
      </span>
    ));
  };

  // Function to get initials from name
  const getInitials = (name) => {
    if (!name) return '?';
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .substring(0, 2); // Get at most 2 initials
  };

  return (
    <section className="sway-testimonials-section" id="testimonials">
      <div className="sway-container">
        <h2 className="sway-section-title">What Our Travelers Say</h2>
        <div className="sway-testimonials-scroll-wrapper">
          <button
            className="sway-scroll-btn sway-scroll-btn--left"
            onClick={() => scroll('left')}
            aria-label="Scroll testimonials left"
          >
            &#8592;
          </button>
          <div className="sway-testimonials-row" ref={rowRef}>
            {loading ? (
              <div className="sway-testimonial-card">
                <div className="sway-testimonial-content">
                  <p>Loading reviews...</p>
                </div>
              </div>
            ) : testimonialData.length > 0 ? (
              testimonialData.map((testimonial) => (
                <div key={testimonial._id} className="sway-testimonial-card sway-testimonial-card--compact">
                  <div className="sway-testimonial-content">
                    <p className="sway-testimonial-text">"{testimonial.comment || testimonial.text || 'No review text'}"</p>
                    <div className="sway-testimonial-footer">
                      <div className="sway-avatar">
                        {getInitials(testimonial.name)}
                      </div>
                      <div className="sway-author-info">
                        <div className="sway-testimonial-rating">
                          {renderStars(parseFloat(testimonial.rating) || 0)}
                        </div>
                        <div className="sway-author-name">{testimonial.name || 'Anonymous'}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="sway-testimonial-card">
                <div className="sway-testimonial-content">
                  <p>No reviews available yet.</p>
                </div>
              </div>
            )}
          </div>
          <button
            className="sway-scroll-btn sway-scroll-btn--right"
            onClick={() => scroll('right')}
            aria-label="Scroll testimonials right"
          >
            &#8594;
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
